// extracted by mini-css-extract-plugin
export default {"wrap":"ListHeader_wrap__ApXO2","text":"ListHeader_text__Sokc6","aside":"ListHeader_aside__OJrYP"};